import React, { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import { busca_qtd_alunos_rec2 } from "../../services/api";
import { ConverteSerie } from "./modulo";

const Qtd_alunos_rec2 = (props) => {
    const [data2, setData2] = useState([]);
    const [avaliacao, setAvaliacao] = useState('AS');
    const [serie, setSerie] = useState('1-1');
    const [notaCorte, setNotaCorte] = useState(24.5);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const cod_unidade = props.un;

    // Lista de opções para o ComboBox de Avaliação
    const avaliacaoOptions = [
        { value: 'AS2', label: 'AS2', notaCorte: 24.5 },
        { value: 'AV2,AS2,AQ2,AP2', label: 'AV2', notaCorte: 35 },
        { value: 'AS4', label: 'AS4', notaCorte: 24.5 },
        { value: 'AV4,AS4,AQ4,AP4', label: 'AV4', notaCorte: 35 }
    ];

    const serieOptions = [
        { value: '1-1', label: '1º Fund I' },
        { value: '1-2', label: '2º Fund I' },
        { value: '1-3', label: '3º Fund I' },
        { value: '1-4', label: '4º Fund I' },
        { value: '1-5', label: '5º Fund I' },
        { value: '1-6', label: '6º Fund II' },
        { value: '1-7', label: '7º Fund II' },
        { value: '1-8', label: '8º Fund II' },
        { value: '1-9', label: '9º Fund II' },
        { value: '2-1', label: '1ª Médio' },
        { value: '2-2', label: '2ª Médio' },
        { value: '2-3', label: '3ª Médio' },
    ];

    const fetchData = async () => {
        try {
            const response = await busca_qtd_alunos_rec2(cod_unidade, serie, avaliacao, notaCorte);
            console.log("RES=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [serie, avaliacao, notaCorte]);

    let chartDatSerie = [];

    if (typeof data2 !== 'undefined') {
        chartDatSerie = data2.map((item, index) => {
            const row = [item.turma];
            row.push(item.disciplina);
            row.push(item.qtd_alunos_rec2);
            row.push(item.total_alunos);
            return row;
        });
    };

    chartDatSerie.unshift(["Turma", "Disciplina", "Alunos em Rec 2", "Total de alunos"]);

    const options = {
        allowHtml: true,
    };

    const formatters = [
        {
            type: "BarFormat",
            column: 4,
            showValue: false,
        },
        {
            type: "ColorFormat",
            column: 4,
            ranges: [
                [-10, 0, "red", "white"],
                [0, 10.1, "blue", "white"],
            ],
        },
    ];

    // Função para atualizar avaliacao e notaCorte
    const handleAvaliacaoChange = (e) => {
        const selectedOption = avaliacaoOptions.find(opt => opt.value === e.target.value);
        setAvaliacao(selectedOption.value);
        setNotaCorte(selectedOption.notaCorte);
    };

    return (
        <div className="Rec" style={{ border: "1px solid #ccc", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
            <center>
                <h5><b>
                    Quantitativo de alunos em REC.
                </b>
                </h5>
            </center>
            <label>
                Avaliação:
                <select value={avaliacao} onChange={handleAvaliacaoChange}>
                    {avaliacaoOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </label>
            <br />
            <label>
                Série:
                <select value={serie} onChange={(e) => setSerie(e.target.value)}>
                    {serieOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </label>
            <br />
            <br />
            <Chart
                chartType="Table"
                width="100%"
                data={chartDatSerie}
                options={options}
            //formatters={formatters}
            />
        </div>
    );
};

export default Qtd_alunos_rec2;
